import { Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ReactComponent as Galleries } from '../../../../../../resources/svg/images.svg';

const Root = styled(Grid)(({ theme }) => ({
	width: '100%',
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	padding: 20,
	gap: '15px',
	flex: 1
}));

const TextGroup = styled(Grid)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	gap: '5px'
}));

const GalleriesIcon = styled(Galleries)(({ theme }) => ({
	width: '100px',
	height: '100px',
	stroke: theme.palette.separator.primary
}));

const Title = styled(Typography)(({ theme }) => ({
	fontSize: '1.2rem',
	fontFamily: 'Quicksand',
	fontWeight: 500,
	color: theme.palette.text.primary
}));

const Subtitle = styled(Typography)(({ theme }) => ({
	fontSize: '1rem',
	fontFamily: 'Quicksand',
	color: theme.palette.text.secondary
}));

const GalleriesPlaceholder = () => {
	return (
		<Root>
			<GalleriesIcon />
			<TextGroup>
				<Title>No Galleries</Title>
				<Subtitle>Click the "Add Gallery" button to add a new gallery.</Subtitle>
			</TextGroup>
		</Root>
	);
};

export default GalleriesPlaceholder;
